import React, { useEffect } from "react";
import "./style.scss";
import Api from "../../Utils/Api";
import Storelist from "../../Store/Actions";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import AddTechnician from "../AddTechnician";
import { Modal, Button, Space, Avatar, Image } from "antd";
import {
  AntDesignOutlined,
  UserOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { logActivity } from "../../Utils/helper";
import { RiCalendarScheduleLine, RiShieldCheckLine } from "react-icons/ri";
import { UsergroupAddOutlined } from "@ant-design/icons";
import ToggleSwitch from "../ToggleSwitch/index";
import { BiSolidEdit } from "react-icons/bi";
import { Tooltip } from "react-tooltip";
import OpenImage from "../OpenImage/OpenImage";
import EditTechnician from "../EditTechnician/EditTechnician";
import SlotAttendance from "../SlotAttendance/SlotAttendance";
import useApiPost from "../../Hooks/usePost";
import { BASE_URL_API, Logo } from "../../appconfig";
import socket from "../../Utils/socket";
import { toast } from "react-toastify";

const Sidebar = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const isWarrantyActive = location.pathname.includes("/warranty");
  // const getStoreSlots = useApiPost();
  const {
    RequestsStore,
    setLoading,
    setCreatemodal_,
    clearCreateRequestData_,
    setServiceDetailsData_,
    CreateRequestDetailsStore,
    BranchDetailStore,
    setAddTechnician,
    PageStore,
    editTechnician,
    setImageViewer,
    setSlotModal,
    setAddresslist_,
    setBikelist_,
  } = Storelist();
  const [technician, setTechnician] = React.useState(null);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [openStates, setOpenStates] = React.useState(
    Array(BranchDetailStore?.branchTechnician?.length).fill(false),
  );
  // const [availableSlots,setAvailableSlots] = React.useState([]);

  const {
    GetRequestsList,
    _Post_MobileNumber,
    GetBranchData,
    GetBranchTechnician,
    SetTechnicianAttendance,
    setInitialAttendance,
    getStoreSlots,
    updateSlots,
    deleteSuperstar,
    _deleteSuperstar,
  } = Api();

  useEffect(() => {
    if (!localStorage.getItem("ACCESS")) {
      console.log("entering");
      Navigate("/login");
    } else {
      GetRequestsList(true);
      GetBranchData(true);
      GetBranchTechnician(localStorage.getItem("BrId"));
      setInitialAttendance();
      getStoreSlots();
    }

    updateSlots();
  }, []);

  const handleDelete = () => {
    Swal.fire({
      icon: "question",
      title: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonText: "Proceed",
      cancelButtonText: "Cancel",
      reverseButtons: true, // optional: Cancel on left, Proceed on right
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Proceed clicked");
        deleteSuperstar(technician.id);
      } else if (result.isDismissed) {
        console.log("Cancelled");
      }
    });
  };

  useEffect(() => {
    if (_deleteSuperstar?.data !== null) {
      if (_deleteSuperstar?.data?.status === 200) {
        toast.success(_deleteSuperstar?.data?.body?.message, {
          position: "top-center",
          onClose: () => {
            setModalOpen(false);
          },
        });
        _deleteSuperstar.setData(null);
        _deleteSuperstar.setError(null);
        GetBranchTechnician(localStorage.getItem("BrId"));
      }
    } else if (_deleteSuperstar?.error !== null) {
      toast.error(_deleteSuperstar?.error?.message);
    }
    setLoading(false);
    _deleteSuperstar.setData(null);
    _deleteSuperstar.setError(null);
  }, [_deleteSuperstar?.data, _deleteSuperstar?.error]);

  const logout = () => {
    Swal.fire({
      title: "Are you sure want to logout?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      icon: "question",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("ACCESS");
        localStorage.removeItem("REFRESH");
        localStorage.removeItem("BrId");
        localStorage.removeItem("cityId");
        localStorage.removeItem("city");
        window.location.reload();
      } else {
      }
    });
  };

  const openModal = (index) => {
    setModalOpen(true);
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
      setTechnician(BranchDetailStore?.branchTechnician[index]);
    }, 500);
  };

  const openTechnicianEditModal = () => {
    setModalOpen(false);
    editTechnician(technician._id);
  };

  const setAttendance = (state, id) => {
    SetTechnicianAttendance({
      status: state,
      technicianid: id,
      branchId: localStorage.getItem("BrId"),
    });
  };

  return (
    <div className="sidebar-container flex flex-col justify-center h-[100vh]  relative  w-full ">
      <div className="header">
        <img
          src={Logo}
          alt="Logo"
          className="cursor-pointer"
          onClick={() => Navigate("/")}
          title="Go to Requests Dashboard"
        />
        <p className="flex justify-between items-center">
          <i className="fa-solid fa-location-dot"></i>
          <span
            className="pl-3 cursor-pointer"
            onClick={() => logActivity("branch_name", {})}
          >
            {CreateRequestDetailsStore?.branchDetail?.branchName}
          </span>
        </p>
      </div>
      <div className="create-request-btn">
        <button
          onClick={() => {
            if (isWarrantyActive) Navigate("/");
            clearCreateRequestData_();
            _Post_MobileNumber.setData(null);
            setAddresslist_([]);
            setBikelist_([]);
            setCreatemodal_(true);
            setServiceDetailsData_(null);
          }}
        >
          <p>Create Request</p>
          <span>
            <i className="fa-solid fa-circle-plus"></i>
          </span>
        </button>
      </div>
      <div className="create-request-btn">
        <button
          onClick={() => {
            if (isWarrantyActive) Navigate("/");
            setAddTechnician(true);
          }}
        >
          <p>Add Superstar</p>
          <span>
            <UsergroupAddOutlined
              style={{ fontSize: "24px", color: "black" }}
            />
          </span>
        </button>
      </div>
      <div className="create-request-btn">
        <button
          onClick={() => {
            if (isWarrantyActive) Navigate("/");
            setSlotModal();
          }}
          data-tooltip-id="common-tooltip"
          data-tooltip-content={`${CreateRequestDetailsStore?.slotsAvailable?.length} days left`}
        >
          <p>Slot Settings</p>
          <span>
            <RiCalendarScheduleLine
              style={{ fontSize: "24px", color: "black" }}
            />
          </span>
        </button>
      </div>
      <div className="create-request-btn warranty-btn">
        <button
          className={isWarrantyActive ? "active" : ""}
          onClick={() => {
            setCreatemodal_(false);
            clearCreateRequestData_();
            setServiceDetailsData_(null);
            Navigate("/warranty");
          }}
          data-tooltip-id="common-tooltip"
          data-tooltip-content="Warranty Information"
        >
          <p>Warranty Information</p>
          <span>
            <RiShieldCheckLine
              style={{
                fontSize: "24px",
                color: isWarrantyActive ? "#2563eb" : "black",
              }}
            />
          </span>
        </button>
      </div>
      <AddTechnician></AddTechnician>
      <SlotAttendance
        data={CreateRequestDetailsStore.slotsAvailable}
      ></SlotAttendance>

      <div className="menu-container"></div>
      <div className=" flex flex-col items-center justify-center technician-container  ">
        <span className="title-heading">Your SuperStars</span>
        <div className=" flex flex-col justify-center items-center w-full">
          {BranchDetailStore?.branchTechnician?.map((item, index) => {
            return (
              // <div className=" w-full flex">
              <div
                className="flex justify-evenly  items-center star-container w-[90%] "
                key={index}
              >
                <Button
                  variant="solid"
                  onClick={() => openModal(index)}
                  className={`superstar-btn  ${
                    item.attendance && item.attendance.status === 1
                      ? "active"
                      : ""
                  }`}
                  data-tooltip-id="common-tooltip"
                  data-tooltip-content={item.name}
                >
                  <Space size={14} wrap className="flex items-center ">
                    <Avatar
                      icon={<UserOutlined />}
                      src={item.profileUrl || undefined}
                      onError={() => true}
                    />
                  </Space>

                  <div className="capitalize font-semibold w-[70%]  text-start">
                    {item.name}
                  </div>
                </Button>
                <span>
                  <span className="text-xs">Attendance</span>
                  <ToggleSwitch
                    checked={
                      item.attendance && item.attendance.status === 1
                        ? true
                        : false
                    }
                    onchange={setAttendance}
                    id={item._id}
                  ></ToggleSwitch>
                </span>
              </div>
            );
          })}
        </div>
        <Modal
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center", // center the text overall
                position: "relative",
                fontWeight: "700",
                width: "100%",
              }}
            >
              <div
                className="absolute top-1 left-1  w-6 h-6 flex justify-center items-center rounded-sm bg-red-500"
                onClick={handleDelete}
              >
                <DeleteOutlined size={300} color="white" />
              </div>
              {/* Icon on the left corner */}
              <BiSolidEdit
                style={{
                  position: "absolute",
                  right: 0,
                  color: "#f59e0b", // optional golden color
                  fontSize: "20px",
                }}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Edit Superstar"
                onClick={openTechnicianEditModal}
              />
              <Tooltip id="my-tooltip" place="top" effect="solid" />

              <p style={{ margin: 0 }}>Superstar Data</p>
            </div>
          }
          loading={loader}
          open={modalOpen}
          onCancel={() => setModalOpen(false)}
          footer={[
            <div key="footer" className="w-full flex justify-center">
              <Button
                key="close"
                onClick={() => {
                  setModalOpen(false);
                  setTechnician(null);
                }}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                Close
              </Button>
            </div>,
          ]}
          closable={false}
          maskClosable={false}
        >
          <Space
            wrap
            size={16}
            className=" w-full flex flex-col justify-center"
          >
            <Avatar
              shape="square"
              size={64}
              icon={<UserOutlined />}
              src={technician?.profileUrl || undefined}
              onError={() => true}
              className="pointer"
              onClick={() => {
                setImageViewer(technician?.profileUrl);
              }}
            />
            <p className="font-semibold text-lg capitalize">
              {technician?.name}
            </p>
          </Space>
          <p className=" flex justify-between modal-items">
            <span>Employee Id:</span>
            <span>{technician?.employeeId}</span>
          </p>
          <p className=" flex justify-between modal-items">
            <span>Role:</span>
            <span>
              {technician?.role?.srolename
                ? technician?.role?.srolename
                : "Nil"}
            </span>
          </p>
          <p className=" flex justify-between modal-items">
            <span>Email:</span>
            <span>{technician?.emailId ? technician?.emailId : "Nil"}</span>
          </p>
          <p className=" flex justify-between modal-items">
            <span>Mobile Number:</span>
            <span>
              {technician?.mobileNumber ? technician?.mobileNumber : "Nil"}
            </span>
          </p>
          <p className=" flex justify-between modal-items">
            <span>Emergency Mobile:</span>
            <span>
              {technician?.emergencyPhone ? technician?.emergencyPhone : "Nil"}
            </span>
          </p>
        </Modal>
        <OpenImage></OpenImage>
        <EditTechnician></EditTechnician>
      </div>
      <div className=" flex justify-center logout-btn w-full ">
        <button
          className="rounded-md w-[100px] bg-orange-500 text-white font-semibold cursor-pointer logout-btn"
          onClick={logout}
        >
          logout
        </button>
      </div>
      <Tooltip id="common-tooltip" place="top" />
    </div>
  );
};

export default Sidebar;
